import { render } from "./ZohoSurveyDrawer.vue?vue&type=template&id=bf3fc518&scoped=true"
import script from "./ZohoSurveyDrawer.vue?vue&type=script&lang=js"
export * from "./ZohoSurveyDrawer.vue?vue&type=script&lang=js"

import "./ZohoSurveyDrawer.vue?vue&type=style&index=0&id=bf3fc518&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3fc518"]])

export default __exports__